import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import AuthShell, { Field, inputCls, SubmitBtn } from "../../components/AuthShell";
import { useAuth } from "../../context/AuthContext";

const countries = ["United Arab Emirates", "Saudi Arabia", "United Kingdom", "India", "Germany", "Italy", "Singapore"];

const Signup = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", company: "", trn: "", country: "United Arab Emirates" });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const on = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(f);
      navigate("/a/dashboard", { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle="Register a new InSolutions workspace in seconds"
      footer={<>Already registered? <Link to="/login" className="text-indigo-600 font-medium hover:underline">Sign in</Link></>}
    >
      <form onSubmit={submit}>
        {err && <div className="mb-4 text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">{err}</div>}
        <div className="grid grid-cols-2 gap-3">
          <Field label="Full name"><input required value={f.name} onChange={on("name")} className={inputCls} placeholder="Jane Doe" /></Field>
          <Field label="Company"><input value={f.company} onChange={on("company")} className={inputCls} placeholder="Acme FZC" /></Field>
        </div>
        <Field label="Work email"><input type="email" required value={f.email} onChange={on("email")} className={inputCls} placeholder="you@company.com" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Country">
            <select value={f.country} onChange={on("country")} className={inputCls}>{countries.map((c) => <option key={c}>{c}</option>)}</select>
          </Field>
          <Field label="TRN (optional)"><input value={f.trn} onChange={on("trn")} className={inputCls} placeholder="100xxxxxxxxxxxx" /></Field>
        </div>
        <Field label="Password">
          <div className="relative">
            <input type={show ? "text" : "password"} required minLength={6} value={f.password} onChange={on("password")} className={inputCls + " pr-10"} placeholder="At least 6 characters" />
            <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
          </div>
        </Field>
        <SubmitBtn loading={loading}>Create account</SubmitBtn>
      </form>
    </AuthShell>
  );
};

export default Signup;
